import { Grid, Button, Typography, Box } from '@mui/material';
import {
  IconIllustrationSmallDevices,
  IconIllustrationSmallMagnifier,
  IconIllustrationSmallDollarBill,
} from '@care/react-icons';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { SxClassProps } from '@/types/common';

const classes: SxClassProps = {
  brandDeviceIcon: {
    width: '65px',
    height: '65px',
    marginTop: -1.5,
    marginLeft: -0.6,
  },
};

interface Props {
  enrollmentURL: string;
}

const JobHowItWorks = ({ enrollmentURL }: Props) => {
  const handleGetStartedClick = () => {
    const amplitudeData = {
      cta_text: 'Get Started',
    };

    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, amplitudeData);
  };

  const howItWorksList = [
    {
      icon: <IconIllustrationSmallDevices sx={classes.brandDeviceIcon} />,
      title: 'Sign up',
      content: 'Create a profile to find jobs that fit your schedule',
    },
    {
      icon: <IconIllustrationSmallMagnifier sx={classes.brandDeviceIcon} />,
      title: 'Search for jobs',
      content: 'Apply to jobs posted by local families hiring in your area',
    },
    {
      icon: <IconIllustrationSmallDollarBill sx={classes.brandDeviceIcon} />,
      title: 'Get hired',
      content: 'Match with families, take jobs as you need them, and start earning!',
    },
  ];

  const howItWorksContent = howItWorksList.map((item) => {
    return (
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
          flexWrap: 'wrap',
          position: 'relative',
          paddingBottom: '30px',

          '&:not(:last-child)': {
            '&:after': {
              content: '"\u22EE"',
              display: 'block',
              position: 'absolute',
              top: '65%',
              left: '22px',
              fontSize: theme.typography.h1.fontSize,
              marginTop: theme.spacing(0.5),
              color: theme.palette.care.navy[800],
            },
          },
        })}>
        <Box
          sx={{
            width: '50px',
            height: '50px',
            marginRight: 3,
            textAlign: 'center',
            alignSelf: 'flex-start',
            paddingTop: '8px',
          }}>
          {item.icon}
        </Box>
        <Box maxWidth="188px" flex="1">
          <Typography variant="body1" color="primary" mb={0.5}>
            {item.title}
          </Typography>
          <Typography variant="body3" color="secondary">
            {item.content}
          </Typography>
        </Box>
      </Box>
    );
  });

  return (
    <Grid item xs={12}>
      <Box mb={{ xs: 1, sm: 7 }}>
        <Typography mb={3} variant="h4" color="primary">
          How it works
        </Typography>
        <Box>{howItWorksContent}</Box>
        <Box>
          <Button
            href={enrollmentURL}
            color="secondary"
            size="small"
            component="a"
            sx={{ textAlign: 'center' }}
            onClick={handleGetStartedClick}
            variant="contained"
            rel="nofollow">
            Get started
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default JobHowItWorks;
